import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import * as reportAction from "../../../actions/ReportAction"
import { IDate, EOTEmployeeType } from "../../../models"

interface IProps {
    utcTime: IDate
    globalHierarchyItemId: string
    filterByPunchPermissionHierarchy: boolean
    filterDirectReportsOnly: boolean
    type: EOTEmployeeType
}

const DashboardOvertimeDetailReports: React.SFC<IProps> = (props: IProps) => {
    const overtimeDetailTypeStr = props.type === EOTEmployeeType.ApproachingOT ? "ApproachingOverTime" : "Overtime"
    return (
        <div style={{ marginTop: -10, marginLeft: 5 }}>
            <IconMenu
                style={{ padding: 0 }}
                iconButtonElement={
                    <IconButton data-intercom-target={`Dashboard-OvertimeDetail-${overtimeDetailTypeStr}-Page-Report`} tooltip={strings.Reports}>
                        <FontIcon className="fa fa-file-text itemActionButton" style={{ fontSize: 20 }} />
                    </IconButton>
                }
            >
                <MenuItem
                    data-intercom-target={`Dashboard-OvertimeDetail-${overtimeDetailTypeStr}-Page-Download`}
                    primaryText={strings.Download}
                    leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                    onTouchTap={() =>
                        reportAction.getDashboardOTEmployeesDownloadReport(
                            props.type,
                            props.globalHierarchyItemId,
                            props.utcTime,
                            props.filterDirectReportsOnly,
                            props.filterByPunchPermissionHierarchy
                        )
                    }
                />
            </IconMenu>
        </div>
    )
}

export default DashboardOvertimeDetailReports